/**
 * Sizes
 */
const sizes = {}
sizes.width = 800
sizes.height = 600

sizes.viewport = {}
sizes.viewport.width = 800
sizes.viewport.height = 600

sizes.default = {}
sizes.default.width = 800
sizes.default.height = 600

sizes.scrollbar = {}
sizes.scrollbar.x = 0
sizes.scrollbar.y = 0

const $sizeDefault = document.createElement('div')
$sizeDefault.style.width = '100%'
$sizeDefault.style.height = '100%'
$sizeDefault.style.position = 'absolute'
$sizeDefault.style.top = 0
$sizeDefault.style.left = 0
$sizeDefault.style.pointerEvents = 'none'

const $sizeViewport = document.createElement('div')
$sizeViewport.style.width = '100vw'
$sizeViewport.style.height = '100vh'
$sizeViewport.style.position = 'absolute'
$sizeViewport.style.top = 0
$sizeViewport.style.left = 0
$sizeViewport.style.pointerEvents = 'none'

/**
 * Callbacks
 */
const callbacks = []

/**
 * Resize
 */
const resizeCallback = () =>
{
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Default
    document.body.appendChild($sizeDefault)
    sizes.default.width = $sizeDefault.offsetWidth
    sizes.default.height = $sizeDefault.offsetHeight
    document.body.removeChild($sizeDefault)

    // Viewport
    document.body.appendChild($sizeViewport)
    sizes.viewport.width = $sizeViewport.offsetWidth
    sizes.viewport.height = $sizeViewport.offsetHeight
    document.body.removeChild($sizeViewport)

    // Scrollbar
    sizes.scrollbar.x = sizes.viewport.width - sizes.default.width
    sizes.scrollbar.y = sizes.viewport.height - sizes.default.height

    // Call callbacks
    for(const _callback of callbacks)
    {
        _callback()
    }
}

window.addEventListener('resize', resizeCallback)
resizeCallback()

/**
 * Mixin
 */
export default {
    created: function()
    {
        this.sizes = sizes

        // Save callbacks
        callbacks.push(this.onResize)
    },

    destroyed: function()
    {
        // Delete callbacks
        callbacks.splice(callbacks.findIndex((_item) => _item === this.onResize), 1)
    },

    methods:
    {
        onResize: function()
        {
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/Sizes.js